import React, { useEffect } from 'react';
import { Modal, Form, Col, Row, Select } from 'antd';
import { AIRCRAFT_TYPES } from '../utils/constants';

function EditAircraftModal(props: any) {
	const { visible, onClose, onSave, saving, aircraft } = props;

	const [form] = Form.useForm();

	function saveForm(values: any) {
		onSave(values);
	}

	useEffect(() => {
		form.resetFields();
		form.setFieldsValue({
			aircraft_type: aircraft.aircraft_type || 'piston',
		});
	}, [visible]);

	return (
		<Modal
			okText="Save"
			cancelText="Cancel"
			title={'Edit Aircraft'}
			okButtonProps={{ loading: saving }}
			visible={visible}
			onOk={() => form.submit()}
			destroyOnClose={true}
			onCancel={onClose}
		>
			<Form form={form} id="userForm" onFinish={saveForm} layout="vertical">
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item initialValue={aircraft.aircraft_type} name="aircraft_type" label="Aircraft Type">
							<Select placeholder={'Select Type'}>
								{Object.keys(AIRCRAFT_TYPES).map((key) => (
									<Select.Option key={key} value={key}>
										{AIRCRAFT_TYPES[key as keyof typeof AIRCRAFT_TYPES]}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
}

export default EditAircraftModal;
